import styled, { css } from 'styled-components';
import dsTokens from '@frete.com/fuel-foundation/fretebras/theme.json';

const widthWrapper = 'calc(100% - 52px)';
const desktopCustom = `1365px`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  text-transform: capitalize;
  flex-wrap: wrap;

  fuel-tooltip {
    text-transform: none;
  }
`;

export const WrapperAlignRigth = styled.div`
  ${({ theme }) => css`
    margin-left: auto;
    max-width: ${widthWrapper};
    padding-right: ${theme.spacing.km1};
  `}
`;

export const ShieldLockIcon = styled.img`
  ${({ theme }) => css`
    width: ${theme.spacing.km4};
    height: ${theme.spacing.km4};
    color: ${theme.color.support.blue.strong};
  `}
`;

export const WrapperOriginAndDestination = styled.div`
  max-width: 225px;
  @media screen and (min-width: ${dsTokens.breakpoint.lg
      .minWidth}) and (max-width: ${desktopCustom}) {
    max-width: 136px;
  }
`;
